import React, { useState, useEffect  } from 'react'
import {
  Container,
  Row,
  Col,
  Input,
  Button,
} from 'reactstrap';
import Alert from 'react-s-alert';
import { validateEmail } from '../../../utils/Helper'
import * as MyAPI from '../../../utils/MyAPI'
import { isMobile } from 'react-device-detect';

// ContactFormPart
const ContactFormPart = (props) => {

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [inquiryType, setInquiryType] = useState('');
  const [subTexts, setSubTexts] = useState("弊社プロダクトに関するご相談、AI関連の受託開発のご相談、プログラマ向け無料AI講習、採用等、お問い合わせは下記フォームよりお願いします。")

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = () => {

    if (props.inquiryType) {
      setInquiryType(props.inquiryType)
    }
    if (props.subTexts) {
      setSubTexts(props.subTexts)
    }
  }

  const _handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  const _handleMessageChange = (e) => {
    setMessage(e.target.value)
  }
  const _handleNameChange = (e) => {
    setName(e.target.value)
  }
  const _handleInquiryTypeChange = (e) => {
    setInquiryType(e.target.value)
  }

  // signup for update
  const _sendButtonClicked = async () => {

    if ( !email || validateEmail(email) === false ){
      Alert.error("メールアドレスに誤りがあります", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return;
    }
    if ( !message || !name ){
      Alert.error("お名前、またはメッセージが入力されていません", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
      return;
    }

    try {
      const params = {
        email: email,
        message: message,
        name: name,
        company: 'shabelab',
        inquiry_type: inquiryType,
      }

      const results = await MyAPI.emailInquirySend(params)

      if (!results) {
        throw Error("サーバーでエラーが発生しました。申し訳ありませんが、暫く経ってから再度ご連絡ください。");
      }
      if (results.status !== 'success') {
        throw Error(results.message)
      }

      setInquiryType('')
      setName('')
      setEmail('')
      setMessage('')

      Alert.success("メッセージを送信しました。返信にはお時間が掛かる場合がございますことをご了承ください。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    } catch (err) {
      console.log("err: ", err)

      Alert.error("メッセージが送信できませんでした。申し訳ありませんが、しばらく経ってから再度お試し頂けますでしょうか。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }
  }

  return (

    <div>
      <Row style={{
        // backgroundColor: '#ffffff',
        paddingTop: 0,
        paddingBottom: 0,
      }}>
        <Container>

          <Row style={{
            marginTop: 60,
            marginBottom: 40,
            paddingLeft: isMobile !== true ? 0 : 40,
            paddingRight: isMobile !== true ? 0 : 40,
           }}>
           <Col md="2" xs="12" />
           <Col md="8" xs="12" style={{
                textAlign: 'center',
              }}>

              {/*<span style={{
                fontSize: isMobile !== true ? 26 : 20,
                // fontFamily: 'GenJyuuGothic-Bold',
                fontWeight: 500,
                textAlign: 'center',
                }}>
                お問い合わせ
              </span>*/}

              <div style={{
                width: '100%',
                paddingTop: 16,
                paddingBottom: 16,
                paddingLeft: 24,
                paddingRight: 24,
                borderRadius: 24,
                backgroundColor: '#1B8CC8',
                color: 'white',
                fontSize: 32,
                cursor: 'pointe',
              }}>
                お問い合わせ
              </div>

            </Col>
            <Col md="2" xs="12" />
          </Row>

          <Row style={{
              marginTop:30,
              marginBottom: 40,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="3" xs="12" />
            <Col md="6" xs="12" style={{
                textAlign: 'center',
              }}>

              <span style={{
                  fontSize: 18,
                  color: '#555555',
                }}>
                {subTexts}
              </span>

            </Col>
            <Col md="3" xs="12" />
          </Row>

          {/* form */}


          <Row style={{
              marginTop:0,
              marginBottom:10,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="2" xs="12" />
            <Col md="2" xs="12" style={{
              textAlign: isMobile === true ? 'left' : 'right',
              marginTop: 8,
            }}>
              <span>お問い合わせ内容</span>
            </Col>
            <Col md="5" xs="12">
              <Input
                onChange={_handleInquiryTypeChange}
                type="select"
                name="inquiryType"
                id="inquiry_type"
                value={inquiryType}>
                <option value="">選択してください</option>
                <option value="alpha_service">音声認識AIに関して</option>
                <option value="alpha_other">その他</option>
              </Input>
            </Col>
            <Col md="3" xs="12" />
          </Row>

          <Row style={{
              marginTop:0,
              marginBottom:10,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="2" xs="12" />
            <Col md="2" xs="12" style={{
              textAlign: isMobile === true ? 'left' : 'right',
              marginTop: 8,
            }}>
              <span>お名前</span>
            </Col>
            <Col md="5" xs="12">
              <Input
                type="text"
                name='name'
                onChange={_handleNameChange}
                value={name}
                placeholder='鈴木　一郎'/>
            </Col>
            <Col md="3" xs="12" />
          </Row>

          <Row style={{
              marginTop:0,
              marginBottom:10,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="2" xs="12" />
            <Col md="2" xs="12" style={{
              textAlign: isMobile === true ? 'left' : 'right',
              marginTop: 8,
            }}>
              <span>メールアドレス</span>
            </Col>
            <Col md="5" xs="12">
              <Input
                type="email"
                name='email'
                onChange={_handleEmailChange}
                value={email}
                placeholder='example@example.com'/>
            </Col>
            <Col md="3" xs="12" />
          </Row>

          <Row style={{
              marginTop:0,
              marginBottom:10,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="2" xs="12" />
            <Col md="2" xs="12" style={{
              textAlign: isMobile === true ? 'left' : 'right',
              marginTop: 8,
            }}>
              <span>メッセージ</span>
            </Col>
            <Col md="5" xs="12">
              <Input
                style={{
                  height: 100,
                }}
                type="textarea"
                name='message'
                onChange={_handleMessageChange}
                value={message}
                placeholder=''/>
            </Col>
            <Col md="3" xs="12" />
          </Row>

          <Row style={{
              marginTop:0,
              marginBottom:50,
              paddingLeft: isMobile !== true ? 0 : 40,
              paddingRight: isMobile !== true ? 0 : 40,
            }}>
            <Col md="4" xs="12" />
            <Col md="5" xs="12" style={{
              textAlign: 'right',
            }}>
              <Button
                style={{
                  width: '100%',
                }}
                color="primary" onClick={_sendButtonClicked}>
                送信する
              </Button>
            </Col>
            <Col md="3" xs="12" />
          </Row>

        </Container>
      </Row>
    </div>
  )
}

export default ContactFormPart
